<template>
  <div class="hello">

    <menupicker value="contacts">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>

    <div id="contact-list" class="center green rcorners1">
      <table width="100%">
        <tr v-for="item in values ">
          <td>{{ item.title }}</td>
          <td>{{ item.name }}</td>
          <td class="nowrap">{{ item.phone }}</td>
        </tr>
      </table>
    </div>

  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';
  import DynamoDb from 'aws-sdk/clients/dynamodb';

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

  export default {
    name: 'Contacts',
    data() {
      return {
        active: 'aboutus',
        msg: 'Contacts - Together Everyone Achieves More',
        values: [],
      }
    },
    methods: {
      loadData(awscredentials) {
        const docClient = new DynamoDb.DocumentClient({
          region: localStorage.getItem('region'),
          credentials: awscredentials,
        });

        const query = {
          TableName: 'contacts-webcontents',
        }
        return new Promise((resolve, reject) => {
          docClient.scan(
            query,
            (error, data) => {
              if (error) {
                console.error('dynamodb error: ' + error.message);
                reject(`dynamodb error: ${error.message}`);
              }
              resolve(data);
            }
          )
        })
      },
      parseData(data) {
        this.values = [];
        var tvalues = [];

        // create an initial ordered list. this might be a sparse list
        // with some positions empty.
        for (let i = 0; i < data.Items.length; i++) {
          tvalues[data.Items[i].id] = data.Items[i];
        }

        // next take the sparse list and build an array holding only actual sorted data
        // used for presentation
        for (let i=0; i<tvalues.length; i++) {
          if (tvalues[i]) {
            this.values[this.values.length] = tvalues[i];
          }
        }
      },
      initCredentials() {
        const credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: localStorage.getItem('poolid'),
        }, {region: localStorage.getItem('region')});
        return credentials;
      }
    },
    mounted() {
      this.loadData(this.initCredentials())
        .then(data => this.parseData(data));
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
    font-size: large;
  }

  ul .link {
    list-style-type: none;
    padding: 0;
  }

  li .link {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  td {
    font-family: "Adobe Devanagari";
    font-size: medium;
    font-weight: bold;
    text-align: center;
  }

  .nowrap {
    white-space: nowrap;
  }

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 100%;
    text-align: left;
  }

  .center {
    margin: auto;
    width: 90vw;
    padding: 10px;
  }

  .green {
    border: 3px solid green;
  }

  .normalli {
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue